import Auth from './auth'
import Tag from './tag'
import ENUM from '../assets/ENUM'

import Store from '@/store'

export default {

    connect: (vue, email, password, provider) => {
        return Auth.connect(vue, email, password, provider)
            .then(response => {
                Tag.infoAll(vue, 'status_final_connection', provider, Auth.Statuses.SUCCESS)
                if (response.status === ENUM.LOGIN_STATUS.CREATED) {
                    vue.$router.push({path: '/fetch'})
                        .catch(() => {})
                } else if (Store.getters.emailToDeleteRedirect) {
                    vue.$router.push({path: '/settings'})
                        .catch(() => {})
                } else {
                    vue.$router.push({path: '/newsletters'})
                        .catch(() => {})
                }
            })
    }
}
